import React from 'react';
import { Mail } from 'lucide-react';
import LegalSection from './LegalSection';

const SUPPORT_EMAIL = 'hello@st-cael.org';

/**
 * Centered contact block — profile-style primary button.
 */
const LegalContactBlock = ({
  title,
  description,
  email = SUPPORT_EMAIL,
  emailLabel,
  action,
}) => (
  <LegalSection title={title} className="legal-contact-section">
    {description ? <p>{description}</p> : null}
    {action || (
      <a href={`mailto:${email}`} className="legal-contact-btn">
        <Mail size={18} />
        {emailLabel || email}
      </a>
    )}
  </LegalSection>
);

export default LegalContactBlock;
export { SUPPORT_EMAIL };
